import _ from 'lodash';

export const getOffsetOfFullText = (container, offset, root) => {
    let currentOffset = offset || 0;
    let currentElement = container;
    // 假设P为段落顶层标签的标记
    if (!currentElement.parentNode || currentElement === root || (currentElement && currentElement.nodeType === 1 && currentElement.getAttribute('i'))) {
        const totalOffset = currentOffset + parseFloat(currentElement.getAttribute('i') || 0);
        return { totalOffset, selfIndex: parseFloat(currentElement.getAttribute('i') || 0), paragraph: parseFloat(currentElement.getAttribute('p') || 0) };
    }
    const nodeList = currentElement.parentNode.childNodes;
    const nodeListIndex = _.findIndex(nodeList, node => node === currentElement);
    if (nodeListIndex !== 0) {
        const takeArray = _.take(nodeList, nodeListIndex);
        _.forEach(takeArray, item => currentOffset += (item.textContent || '').length);
    }
    return getOffsetOfFullText(currentElement.parentNode, currentOffset, root);
};

export const getOffsetMeta = (wrapRange, root) => {
    const isInSameParagraph = wrapRange.startContainer === wrapRange.endContainer;
    const rangeString = wrapRange.toString();

    const startOffset = getOffsetOfFullText(wrapRange.startContainer, wrapRange.startOffset, root);
    const startString = isInSameParagraph ? rangeString : wrapRange.startContainer.textContent.slice(wrapRange.startOffset);
    const sliceStartString = startString.slice(0, 50);

    const endOffset = getOffsetOfFullText(wrapRange.endContainer, wrapRange.endOffset, root);
    const endString = isInSameParagraph ? rangeString : wrapRange.endContainer.textContent.slice(0, wrapRange.endOffset);
    const sliceEndString = endString.slice(-50);

    const startMeta = {
        i: startOffset.selfIndex,
        p: startOffset.paragraph,
        estimate_offset: startOffset.totalOffset,
        content: sliceStartString,
    };
    const endMeta = {
        i: endOffset.selfIndex,
        p: endOffset.paragraph,
        estimate_offset: endOffset.totalOffset - endString.length + (endString.length - sliceEndString.length),
        content: sliceEndString,
    };
    const offsetMeta = {
        fullText: rangeString,
        startMeta,
        endMeta,
    };
    return offsetMeta;
};

export const checkLegalityUpward = ({ root, checkNode, illegalTagNameList = [], illegalClassNameList = [] }) => {
    const isIllegal = checkNode && checkNode.nodeType === 1 && (illegalTagNameList.includes(checkNode.tagName) || _.some(illegalClassNameList, name => checkNode.className.includes(name)));
    if (!checkNode.parentNode || checkNode === root || isIllegal) return !isIllegal;
    return checkLegalityUpward({ root, checkNode: checkNode.parentNode, illegalTagNameList, illegalClassNameList });
};

export const checkLegalityDownward = ({ checkNodeList, illegalTagNameList = [], illegalClassNameList = [] }) => {
    let isIllegal = false;
    const childrenList = [];
    _.forEach(checkNodeList, item => {
        if (illegalTagNameList.includes(item.tagName) || _.some(illegalClassNameList, name => item.className.includes(name))) isIllegal = true;
        if (item.children.length) _.forEach(item.children, child => childrenList.push(child));
    });
    if (!checkNodeList.length || isIllegal) {
        return isIllegal;
    }
    return checkLegalityDownward({ checkNodeList: childrenList, illegalTagNameList, illegalClassNameList });
};

export const getDuplicateId = (root, range, attr) => {
    const getMatchedNode = ($root, $node, $attr) => {
        const isMatchedNode = $node.getAttribute && $node.getAttribute($attr);
        if (isMatchedNode || $node === $root) return $node;
        return getMatchedNode($root, $node.parentNode, $attr);
    };
    const startNode = getMatchedNode(root, range.startContainer, attr);
    const endNode = getMatchedNode(root, range.endContainer, attr);
    const duplicateId = (startNode.getAttribute(attr) === endNode.getAttribute(attr)) ? startNode.getAttribute(attr) : undefined;
    return duplicateId;
};
